import { userApiClient } from '../utils/apiClient';
import { extractErrorMessage } from '../utils/apiErrorHandler';

class PaymentAPI {
  constructor() {
    this.api = userApiClient;
  }

  async createOrder(orderData) {
    try {
      const response = await this.api.post('/payment/create-order', orderData);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '创建支付订单失败');
    }
  }

  async getOrderStatus(orderNo) {
    try {
      const response = await this.api.get(`/payment/order/${orderNo}`);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '查询订单状态失败');
    }
  }

  async syncOrderStatus(orderNo) {
    try {
      const response = await this.api.post(`/payment/sync-order-status/${orderNo}`);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '同步订单状态失败');
    }
  }

  async refund(refundData) {
    try {
      const response = await this.api.post('/payment/refund', refundData);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '申请退款失败');
    }
  }

  async getUserSubscription(userId) {
    try {
      const response = await this.api.get(`/payment/subscription/${userId}`);
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '获取订阅信息失败');
    }
  }

  async getSubscriptionPlans() {
    try {
      const response = await this.api.get('/payment/subscription-plans');
      return response.data;
    } catch (error) {
      throw new Error(extractErrorMessage(error) || '获取订阅计划配置失败');
    }
  }
}

const paymentAPI = new PaymentAPI();
export default paymentAPI;
